import React from 'react';
import './main-shell.scss';
import {Outlet} from 'react-router-dom';
import {ErrorBoundary} from 'react-error-boundary';
import {FormattedMessage} from 'react-intl';
import ArrowRightSvg from '../../assets/icons/arrow-right.svg';
// import LogoDarkModeFalseSvg from '../../assets/logo-dark-mode-false.png';
import classNames from 'classnames';
import SuspenseList from '../../components/SuspenseList';
import ErrorFallback from '../../components/ErrorFallback';
import MainHeader from '../main-header/main-header';
import MainFooter from '../main-footer/main-footer';


const formLink = 'https://docs.google.com/forms/d/e/1FAIpQLSesrYhmBpJV-mvZD9AHOM79MyP8CcgSzFANSQWNby__dilgRw/viewform';

const Shell = () => {
    const [menuFlag, setMenuFlag] = React.useState(false);
    return (
        <>
        <div className='background-color-gray-800'>
            <div className='view'>
                <div className='block'>
                    <div className='min-height-2rem display-flex justify-content-center-end'>
                        <a 
                            href={formLink} 
                            target='_blank' 
                            rel='noopener noreferrer'
                            className='display-flex align-items-center text-sm medium color-gray-25'
                        >
                            <FormattedMessage defaultMessage='Use Ottry in your business'/>
                            <ArrowRightSvg className='margin-left-0dot5rem color-gray-25 height-1rem width-1rem'/>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <MainHeader menuFlag={menuFlag} setMenuFlag={setMenuFlag} />
        <div className={classNames({'hide-small': menuFlag})}>
            <SuspenseList revealOrder='forwards'>
                <ErrorBoundary {...{FallbackComponent: ErrorFallback}}>
                    {/* ToDo: should the shell have React.Suspense wrapper for outlet? SuspenseList? */}
                    {/* <React.Suspense fallback={'Loading...'}> */}
                        <Outlet/>
                    {/* </React.Suspense> */}
                </ErrorBoundary>
                <MainFooter/>
            </SuspenseList>
        </div>
        </>
    );
};

export const ErrorBoundaryShellWrapper = React.memo(({children}) => {
    const [menuFlag, setMenuFlag] = React.useState(false);
    return (
        <>
            <MainHeader menuFlag={menuFlag} setMenuFlag={setMenuFlag} />
            <div className={classNames({'hide-small': menuFlag})}>
                <SuspenseList revealOrder='forwards'>
                    <ErrorBoundary {...{FallbackComponent: ErrorFallback}}>
                        {children}
                    </ErrorBoundary>
                </SuspenseList>
            </div>
        </>
    );
});

export default React.memo(Shell);